import React from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import SubjectsList from "../components/SubjectsList";
import { SUBJECTS_LIST } from "../constants";
import { endOfTitle } from "../../../constants/constants";
import "./style.css";

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: "2rem",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  subjectsListContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
}));

const CardsPage = () => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Private Classes{endOfTitle}</title>
      </Helmet>
      <Container maxWidth="lg">
        <h1 className={classes.header}>Private Classes</h1>
        <SubjectsList subjectsList={SUBJECTS_LIST} />
      </Container>
    </>
  );
};

export default React.memo(CardsPage);
